import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';

const DataSection = () => {
  const [sectionRef, isSectionVisible] = useScrollReveal();

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      {/* Colorful Inks Background */}
      <div className="absolute inset-0">
        <img
          src="/inks.webp"
          alt="Colorful Inks in Water"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div
        ref={sectionRef}
        className={`relative z-10 section-container text-center reveal ${isSectionVisible ? 'visible' : ''}`}
      >
        <span
          className="inline-block text-white/80 text-sm font-semibold uppercase tracking-[3px] mb-4"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Imprint's comprehensive data capture will enable you to make powerful decisions
        </span>

        <h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          See your business<br />in full colour...
        </h2>

        {/* Datastream Technology Logo - Centered & Larger */}
        <div className="flex justify-center mb-10">
          <img 
            src="/datastream-logo.webp" 
            alt="Datastream Technology" 
            className="h-16 md:h-20 lg:h-24 w-auto"
          />
        </div>

        <div className="block">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-primary text-xs"
          >
            Let's Talk
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default DataSection;
